var _rect, _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProsecaptainAssistant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#E4ECE4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.8909,
    cy: 37.1019,
    r: 8.11359,
    fill: "url(#paint0_linear_1450_16004)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9395 11.57C26.8555 9.98332 29.1457 9.98332 30.0617 11.57L45.0518 37.5335C45.9678 39.1201 44.8227 41.1034 42.9906 41.1034H13.0106C11.1785 41.1034 10.0334 39.1201 10.9494 37.5335L25.9395 11.57Z",
    fill: "url(#paint1_linear_1450_16004)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8926 28.9863C32.3735 28.9863 36.0057 32.6188 36.0059 37.0996C36.0059 38.55 35.6237 39.9107 34.957 41.0889H20.8281C20.1614 39.9107 19.7793 38.55 19.7793 37.0996C19.7795 32.6188 23.4117 28.9863 27.8926 28.9863Z",
    fill: "url(#paint2_linear_1450_16004)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1450_16004",
    x1: 36.0045,
    y1: 28.892,
    x2: 36.0045,
    y2: 45.3118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F61AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42367A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1450_16004",
    x1: 28.0006,
    y1: 10,
    x2: 28.0006,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D9C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63AD61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1450_16004",
    x1: 9.5,
    y1: 30,
    x2: 8.63797,
    y2: 41.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00831732,
    stopColor: "#C8C5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F61AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProsecaptainAssistant);
export default __webpack_public_path__ + "static/media/prosecaptain-assistant.1851dd3baabe8a1d43134b76aa0685f1.svg";
export { ForwardRef as ReactComponent };